import { Box, Container, Stack } from '@chakra-ui/react'
import { graphql } from 'gatsby'
import React, { useMemo } from 'react'

import NavHeading from '../containers/NavHeading'
import Blocks from '../containers/Blocks'
import arrToObj from '../helpers/arrToObj'

const Subpage = ({ data: { portal, subPage } }) => {
  const items = useMemo(() => {
    const itemIds = arrToObj(subPage.items, 'itemId')
    return subPage.itemOrders?.map(itemId => itemIds[itemId]).filter(Boolean) || []
    // return portal.blocks.items.filter(item => item.linkId === subPage.linkId)
  }, [subPage])
  return (
    <Container px="0" minHeight="100%" bg="white">
      <Box
        p="2"
        position={`sticky`}
        top="0"
        zIndex={`sticky`}
        bg="white"
        boxShadow={`md`}
      >
        <NavHeading title={subPage?.title} data={portal} />
      </Box>
      <Stack spacing="2" p="4">
        {items ? (
          <Blocks
            id={subPage.firebaseId}
            blocks={subPage.mode === 'slider' ? [{
              id: subPage.firebaseId,
              type: 'collection',
              items,
            }] : items.map(item => ({
              id: `${subPage.firebaseId}.${item?.itemId}`,
              type: 'collection',
              items: [item],
            }))}
            links={portal.links}
          />
        ) :  null}
      </Stack>
    </Container>
  )
}

export default Subpage

export const query = graphql`
  query SubPageQuery ($firebaseId: String, $pageId: String) {
    portal(firebaseId: {eq: $firebaseId}) {
      ...PartialPortalData
      links {
        linkId
        mode
        url
      }
    }
    subPage(id: {eq: $pageId}) {
      firebaseId
      slug
      title
      itemOrders
      items {
        alt
        cta
        description
        image {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1280)
            }
          }
        }
        itemId
        linkId
        text
        title
      }
    }
  }
`
